import { AnalyticsBrowser } from '@segment/analytics-next'
import { createContext } from 'react'

const defaultAnalyticsContext = {
  analytics: new AnalyticsBrowser()
}

export const AnalyticsContext = createContext(defaultAnalyticsContext)
